import styled from "styled-components";

type ImageProps = {
  $img: string;
};
export const TeamContainer = styled.div<ImageProps>`
  display: block;
  margin: 0 auto;
  height: 730px;
  width: 1320px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  margin-top: 40px;

  @media (max-width: 430px) {
    display: none;
  }
`;

export const TeamContainerMobile = styled.div<ImageProps>`
  display: none;
  margin: 0 auto;
  height: 870px;
  width: 1320px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  margin-top: 40px;

  @media (max-width: 430px) {
    display: block;
  }
`;
export const ImgContainer = styled.div<ImageProps>`
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: top;
  align-items: center;
  flex-direction: column;
  width: 70%;
  height: 550px;
  width: 1300px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  background-position: center;

  @media (max-width: 430px) {
    width: 393px;
    border-radius: 0px;
  }
`;

export const PhotoMobile = styled.div<ImageProps>`
  display: none;
  margin: 0 auto;
  width: 70%;
  height: 540px;
  width: 650px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  margin-top: 40px;
  margin-bottom: 40px;
  @media (max-width: 430px) {
    display: block;
    margin-left: 10px;
  }
`;
export const Photo = styled.div<ImageProps>`
  display: block;
  margin: 0 auto;
  width: 70%;
  height: 800px;
  width: 650px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  margin-top: 40px;
  margin-bottom: 40px;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const LPContainer = styled.div`
  margin: 0 auto;
  width: 1300px;
  display: flex;
  flex-direction: row;
`;
export const BoxContainer = styled.div`
  margin: 0 auto;
  justify-content: center;
  width: 1300px;
  display: flex;
  flex-direction: row;
  @media (max-width: 430px) {
    width: 393px;
    font-size: 20px;
    flex-direction: column;
  }
`;
export const Box2 = styled.div`
  width: 25%;
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid #b4b4b4;
  border-right: 1px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    margin: 0;
    width: 393px;
    align-items: center;
    padding: 0;
  }
`;
export const Box21 = styled.div`
  width: 25%;
  padding: 20px;
  margin-top: 20px;
  border-top: 1px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    margin: 0;
    width: 393px;
    align-items: center;
    padding: 0;
  }
`;
export const Container = styled.div`
  margin: 0 auto;
  max-width: 900px;
  z-index: 2;
`;
export const TextContainer = styled.div`
  width: 650px;
  margin-left: 24px;
`;
export const SmallText = styled.div`
  margin: 0 auto;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin-top: 40px;
  width: 850px;

  @media (max-width: 430px) {
    width: 393px;
    font-size: 20px;
  }
`;
export const LinkedIn = styled.a`
  font-family: Avenir Next;
  text-decoration: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  color: #55749f;
  margin-top: 30px;
  margin-bottom: 30px;
`;
export const Br = styled.div`
  border: 1px solid #b4b4b4;
  margin-top: 20px;
`;
export const Text1 = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 50px;
  font-family: Cormorant Infant;
  font-weight: 500;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  @media (max-width: 430px) {
    width: 383px;
    font-size: 40px;
    margin-top: 0;
  }
`;
export const Text12 = styled.div`
  display: block;
  font-size: 50px;
  font-family: Cormorant Infant;
  font-weight: 500;
  text-align: left;
  color: #000000;
  margin-top: 30px;
`;
export const SmallText22 = styled.div`
  margin: 0 auto;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  margin-top: 10px;
`;
export const SmallText23 = styled.div`
  margin: 0 auto;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: left;
  margin-top: 20px;
`;
export const SmallText2 = styled.div`
  margin: 0 auto;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  margin-top: 15px;
  letter-spacing: 0.1px;
`;
export const H1 = styled.h1`
  font-family: Cormorant Infant;
  font-size: 60px;
  margin: 0 auto;
  font-weight: 500;
  text-align: center;
  color: white;
  margin-bottom: 50px;
  padding-top: 50px;
  width: 850px;

  @media (max-width: 430px) {
    width: 393px;
    font-size: 50px;
  }
`;
export const SmallH1 = styled.p`
  margin: 0 auto;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: white;
  width: 600px;

  @media (max-width: 430px) {
    width: 383px;
    font-size: 20px;
  }
`;
